/* eslint-disable max-len */

import React from 'react';
import type { SVGProps } from 'react';

export interface LinkProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

export const Link: React.FC<LinkProps> = ({ color = 'none', ...props }) => {
  return (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5976 5.9973C14.1388 4.45956 16.6377 4.45956 18.1789 5.99731C19.7201 7.53505 19.7201 10.0282 18.1789 11.566L16.5578 13.1834C16.2883 13.4523 15.8513 13.4523 15.5818 13.1834C15.3123 12.9145 15.3123 12.4785 15.5818 12.2096L17.2029 10.5922C18.205 9.59224 18.205 7.97105 17.2029 6.97112C16.2007 5.9712 14.5758 5.9712 13.5736 6.97112L11.0832 9.45597C10.081 10.4559 10.081 12.0771 11.0832 13.077C11.3265 13.3198 11.6052 13.5028 11.902 13.6272C12.2534 13.7746 12.4185 14.1783 12.2708 14.5289C12.1231 14.8795 11.7185 15.0442 11.3671 14.8968C10.9083 14.7044 10.4791 14.422 10.1072 14.0508C8.56595 12.5131 8.56595 10.0199 10.1072 8.48215L12.5976 5.9973ZM11.7295 9.48466C11.8772 9.13407 12.2818 8.96932 12.6332 9.11668C13.092 9.3091 13.5212 9.59156 13.8931 9.9627C15.4344 11.5004 15.4344 13.9936 13.8931 15.5314L11.4027 18.0162C9.86147 19.554 7.36266 19.554 5.82144 18.0162C4.28022 16.4785 4.28022 13.9853 5.82144 12.4475L7.44251 10.8301C7.71203 10.5612 8.14901 10.5612 8.41853 10.8301C8.68805 11.099 8.68804 11.535 8.41852 11.8039L6.79746 13.4214C5.79528 14.4213 5.79528 16.0425 6.79746 17.0424C7.79964 18.0423 9.42449 18.0423 10.4267 17.0424L12.9171 14.5576C13.9193 13.5576 13.9193 11.9364 12.9171 10.9365C12.6738 10.6937 12.3951 10.5107 12.0983 10.3863C11.7469 10.2389 11.5818 9.83524 11.7295 9.48466Z"
        fill={color}
      />
    </svg>
  );
};
